import React from "react";
import "./loading.less";
const Loading = () => {
  return <div className="loading">加载中...</div>;
};
export default Loading;
